const Carrito = () =>{

    return(
        <div className="App">
            <div className='Seccion' id='Carrito'>
                <h1>Pagina para mostrar carrito</h1>
            </div>
        </div>
    );
}
    
    export default Carrito;